// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__9bMIx","checkbox":"Checkbox_checkbox__2CTPm","checkboxInverted":"Checkbox_checkboxInverted__MKVhr","label":"Checkbox_label__spUTH"};